<template>
  <div class="home">
    <page-header></page-header>

    <div
      class="modal fade parcel_number"
      id="exampleModal1"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      style="display: none"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content text-center rounded-0">
          <div class="modal-header border-0">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeModalErrorWindow()"
            ></button>
          </div>
          <div class="modal-body">
            <h2>PARCEL NUMBER</h2>
            <p class="parcel_number-value">2234234</p>
            <div class="information-parcel text-start">
              <p class="fw-bold text-start">
                We don’t have information for the package you entered due to one
                of the following reasons:
              </p>
              <ul class="parcel_list text-start">
                <li>
                  The package ID you entered is incorrect or missing. Please
                  review it and try again.
                </li>
                <li>
                  The postal code you entered is incorrect or missing. Please
                  review it and try again.
                </li>
                <li>
                  We have not received information for this item from the sender
                  yet.
                </li>
              </ul>
              <p>
                These results reflect the most recent updates in our system. Our
                customer service representatives have access to the same
                information presented here and are unable to provide further
                details at this time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile version of slider -->
    <div class="bannerSlider mobile_slider-section d-lg-none d-block">
      <div class="banner-mobile-center">
        <swiper
          class="banner"
          :autoplay="{ delay: 7500, disableOnInteraction: false }"
          :modules="modules"
          effect="fade"
          :pagination="{ clickable: true }"
        >
          <swiper-slide>
            <img src="../assets/mobile-slider.png" />
            <div class="bannerCaptionMobile">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>We're <span> experienced</span></h2>
                  <p>We've delivered newspapers for more than 100 years.</p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/mobile-slider.png" />
            <div class="bannerCaptionMobile">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>We're <span> fast</span></h2>
                  <p>Paired with our top-of-the-line technology</p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/mobile-slider.png" />
            <div class="bannerCaptionMobile">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>We're <span> cost effective</span></h2>
                  <p>We offer flat rate competitive pricing</p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/mobile-slider.png" />
            <div class="bannerCaptionMobile">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>We're <span> comprehensive</span></h2>
                  <p>We're proud to offer a self-serve tracking system</p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/mobile-slider.png" />
            <div class="bannerCaptionMobile">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>We're <span> reliable</span></h2>
                  <p>
                    We secure drop all packages and send a photo immediately
                    after delivery
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/mobile-slider.png" />
            <div class="bannerCaptionMobile">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>We're <span> Postmedia Parcel Services</span></h2>
                  <p>
                    Postmedia Parcel Services is your best choice for parcel
                    delivery across Canada
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <!-- end of mobile slider -->
    <div class="bannerSlider desktop-slider d-lg-block d-none">
      <div class="banner-container-left-half">
        <swiper
          class="banner"
          :autoplay="{ delay: 7500, disableOnInteraction: false }"
          :modules="modules"
          effect="fade"
          :pagination="{ clickable: true }"
        >
          <swiper-slide>
            <img src="../assets/banner1.jpg" />
            <div class="bannerCaption">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>We're <span> experienced</span></h2>
                  <p>We've delivered newspapers for more than 100 years.</p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/banner1.jpg" />
            <div class="bannerCaption">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>We're <span> fast</span></h2>
                  <p>Paired with our top-of-the-line technology</p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/banner1.jpg" />
            <div class="bannerCaption">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>We're <span> cost effective</span></h2>
                  <p>We offer flat rate competitive pricing</p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/banner1.jpg" />
            <div class="bannerCaption">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>We're <span> comprehensive</span></h2>
                  <p>We're proud to offer a self-serve tracking system</p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/banner1.jpg" />
            <div class="bannerCaption">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>We're <span> reliable</span></h2>
                  <p>
                    We secure drop all packages and send a photo immediately
                    after delivery
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/banner1.jpg" />
            <div class="bannerCaption">
              <div class="container-sm">
                <div class="bannertextBox">
                  <h2>We're <span> Postmedia Parcel Services</span></h2>
                  <p>
                    Postmedia Parcel Services is your best choice for parcel
                    delivery across Canada
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="TrackingBox" id = "">
      <div class="">

      <div class="row">
        <div class="col-md-12 col-lg-4 textLeft">
          <h1>Track Your <span>Shipment</span></h1>
        </div>
        <div class="col-md-12 col-lg-8 InputRight">
          <div class="">
            <input
              type="text"
              name="bniTrackingID"
              v-model="tracking_id"
              class="form-control"
              placeholder="Enter your parcel number"
              aria-label="Enter your parcel number"
              aria-describedby="button-addon2"
            />
          </div>
          <div class="input-group">
            <input
              type="text"
              v-model="postal_code"
              name="bniPostalCode"
              class="form-control"
              placeholder="Enter your postal code"
              aria-label="Enter your parcel number"
              aria-describedby="button-addon2"
            />
            <button
              class="btn track-button"
              @click="submitToTrackingPage()"
              name="trackButton"
              value="trackButton"
              id="button-addon2"
            >
              SUBMIT
            </button>
          </div>

          <p>
            Need Support? <a href="#/support" title="Click here">Click here</a>
          </p>
        </div>
      </div>
      </div>
    </div>
    <div id="what-sets-section" class="whatSetSection">
      <div class="container-sm">
        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="leftText">
              <h2 class="pt-5">What sets us apart</h2>
              <p>
                Covering over 8 million households across Canada, choose
                Postmedia Parcel Services to deliver your packages anywhere
                across the country
              </p>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <swiper
              class="trackingSlider"
              :slidesPerView="3"
              :centeredSlides="true"
              :loop="true"
              :modules="modules"
              :autoplay="{ delay: 7500, disableOnInteraction: false }"
            >
              <swiper-slide>
                <div class="itemBox">
                  <div class="iconBox">
                    <img src="../assets/proofIcon.png" alt="" />
                  </div>
                  <div class="itemText">
                    <h4>Proof of delivery</h4>
                    <p></p>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="itemBox">
                  <div class="iconBox">
                    <img src="../assets/realtimeIcon.png" alt="" />
                  </div>
                  <div class="itemText">
                    <h4>Tracking updated every 5 minutes</h4>
                    <p></p>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="itemBox">
                  <div class="iconBox">
                    <img src="../assets/coveringIcon.png" alt="" />
                  </div>
                  <div class="itemText">
                    <h4>Covering over 8 million households</h4>
                    <p></p>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="itemBox">
                  <div class="iconBox">
                    <img src="../assets/api.png" alt="" />
                  </div>
                  <div class="itemText">
                    <h4>
                      Enhanced API allows direct interface from your pos system
                    </h4>
                    <p></p>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="itemBox">
                  <div class="iconBox">
                    <img src="../assets/support-icon.png" alt="" />
                  </div>
                  <div class="itemText">
                    <h4>Call centre support</h4>
                    <p></p>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="itemBox">
                  <div class="iconBox">
                    <img src="../assets/tracking-icon.png" alt="" />
                  </div>
                  <div class="itemText">
                    <h4>Billingual customer tracking portal</h4>
                    <p></p>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <div class="ourNetworkSection">
      <div class="container-sm">
        <div class="row">
          <div class="col-md-12 col-lg-7">
            <div class="leftMapBox">
              <h3>
                OUR NETWORK IS<br />
                COAST TO COAST
              </h3>
              <img src="../assets/pmmap.png" alt="Map" />
            </div>
          </div>
          <div class="col-md-12 col-lg-5">
            <div class="mapBulletsText">
              <ul>
                <li>A trusted and experienced network</li>
                <li>Next day best in class delivery</li>
                <li>Flat rate competitive pricing</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="getInTouchSection">
      <div class="container-sm">
        <div class="getInTouch">
          <h5>
            <p>Need more information or support?</p>
            <a href="#/support" title="">Get in touch with us today!</a>
          </h5>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import PageHeader from "./PageHeader.vue";
import PageFooter from "./PageFooter.vue";
import { Pagination, EffectFade, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import axios from "axios";
import { parcel_api } from '@/js_utils/urls.js'


import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export default {
  name: "HomePage",
  components: {
    PageHeader,
    Swiper,
    SwiperSlide,
    PageFooter,
  },
  beforeMount() {
    scroll(0, 0);
  },

  mounted() {
    /* eslint-disable */
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);

    if (params.size != 0) {
      
      //check to make sure that the postal code and tracking IDs are in the correct formats
      if(params.get("bniPostalCode").match("^([a-zA-Z]\d[a-zA-Z]\s?\d[a-zA-Z]\d)$") != null && params.get("bniTrackingID").match("^[A-Za-z0-9_-]*$") != null) {
        this.tracking_id = params.get("bniTrackingID");
        this.postal_code = params.get("bniPostalCode"); 
        this.submitToTrackingPage();
      }
    }
  },

  methods: {
    submitToTrackingPage() {
      this.postal_code = this.postal_code.trim().toUpperCase();
      this.tracking_id = this.tracking_id.trim().toUpperCase();
      let submit_button = document.querySelector(".track-button");
      submit_button.disabled = true;

      if (this.tracking_id.trim() == "" || this.postal_code.trim() == "") {
        document.querySelector(".parcel_number").classList.add("show");
        document.querySelector(".parcel_number").style.display = "block";
        document.querySelector(".parcel_number").ariaModal = true;
        document.querySelector(".parcel_number-value").innerHTML =
          this.tracking_id;
        submit_button.blur();
        submit_button.disabled = false;
      } else {
        if (this.postal_code.length == 6) {
          let first_half = this.postal_code.slice(
            0,
            this.postal_code.length / 2
          );
          let second_half = this.postal_code.slice(
            this.postal_code.length / 2,
            this.postal_code.length
          );
          this.postal_code = first_half + " " + second_half;
        }

        let tracking_postal = this.tracking_id + "+" + this.postal_code;
        axios
          .get(parcel_api.concat('/query/'+tracking_postal))
          .then((res) => {
            if (res["data"]["statuses"] == undefined) {
              document.querySelector(".parcel_number").classList.add("show");
              document.querySelector(".parcel_number").style.display = "block";
              document.querySelector(".parcel_number").ariaModal = true;
              document.querySelector(".parcel_number-value").innerHTML =
                this.tracking_id;
            } else {
              submit_button.blur();
              submit_button.disabled = false;
              sessionStorage.setItem("tracking_id", this.tracking_id);
              sessionStorage.setItem("postal_code", this.postal_code);
              sessionStorage.setItem("data", JSON.stringify(res));
              this.$router.push("/track-your-shipment");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      submit_button.blur();
      submit_button.disabled = false;
    },
    closeModalErrorWindow() {
      document.querySelector(".parcel_number").classList.remove("show");
      document.querySelector(".parcel_number").style.display = "none";
      document.querySelector(".parcel_number").ariaModal = false;
      document.querySelector(".parcel_number-value").innerHTML = "";
    },
  },
  data: function () {
    return {
      tracking_id: "",
      postal_code: "",
    };
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSliderChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSliderChange,
      modules: [Pagination, EffectFade, Autoplay],
    };
  },
};
</script>